import React, { memo } from "react";

import { formatCurrency } from "helpers";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { VEHICLE_WIZARD_SAMPLE } from "../consts";
import { VehicleWizardSceneProps } from "../types";

/** Korak "Cijena": nabavna cijena, porez i prodajna cijena, razlika u cijeni i kamo cijena ide dalje. */
const PriceScene: React.FC<VehicleWizardSceneProps> = ({ vehicleInfo }) => {
  const netPrice = vehicleInfo.netPrice ?? VEHICLE_WIZARD_SAMPLE.netPrice;
  const specialTax = vehicleInfo.specialTax ?? VEHICLE_WIZARD_SAMPLE.specialTax;
  const sellingPrice = vehicleInfo.sellingPrice ?? VEHICLE_WIZARD_SAMPLE.sellingPrice;
  const margin = sellingPrice - netPrice - specialTax;
  const marginPercent = sellingPrice > 0 ? Math.max(0, Math.round((margin / sellingPrice) * 100)) : 0;

  const rows = [
    { label: "Nabavna cijena", value: netPrice },
    { label: "Posebni porez", value: specialTax },
  ];

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Cijena vozila</div>
          <div className="mt-3 space-y-2">
            {rows.map((row) => (
              <div key={row.label} className="flex justify-between text-[0.7rem]">
                <span className="text-slate-500">{row.label}</span>
                <span className="font-semibold text-slate-700">{formatCurrency.format(row.value)}</span>
              </div>
            ))}
          </div>
          <div className="mt-4 rounded-md bg-gradient-to-br from-blue-600 to-blue-700 p-3 text-white">
            <div className="text-[0.65rem] text-blue-100">Prodajna cijena</div>
            <div className="text-2xl font-bold">{formatCurrency.format(sellingPrice)}</div>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-xs font-bold text-slate-800">Razlika u cijeni</div>
          <div className="mt-1 text-lg font-bold text-emerald-600">{formatCurrency.format(margin)}</div>
          <div className="mt-3 h-2 rounded-full bg-slate-100">
            <div
              className="h-full rounded-full bg-gradient-to-r from-emerald-400 to-emerald-500"
              style={{ width: `${Math.min(100, marginPercent * 4)}%` }}
            />
          </div>
          <div className="mt-1 text-[0.6rem] text-slate-400">{marginPercent} % prodajne cijene</div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Cijena ide u ponudu"
          subtitle="Ponuda i račun preuzimaju iznose"
          iconClassName="bg-emerald-100"
          icon={<span className="text-sm font-bold text-emerald-600">€</span>}
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(PriceScene);
